import { sellerDashboard } from './sellerDashboard';

export const tracking = {
  sellerDashboard,
};
